import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Trash2, ExternalLink } from 'lucide-react';

// 1. Interface add karo
interface Blog {
  id: number;
  title: string;
  slug: string;
}

const ManageBlogs = () => {
    // 2. State ko define karo
    const [blogs, setBlogs] = useState<Blog[]>([]);
    const [loading, setLoading] = useState(true);

    const fetchBlogs = () => {
        axios.get('https://www.projectinfotech.in/api/blogs')
            .then(res => {
                setBlogs(res.data);
                setLoading(false);
            })
            .catch(err => {
                console.error("Error fetching blogs", err);
                setLoading(false);
            });
    };

    useEffect(() => { fetchBlogs(); }, []);

    const deleteBlog = (id: number) => {
        if(window.confirm("Are you sure you want to delete this blog?")) {
            axios.delete(`https://www.projectinfotech.in/api/admin/blog-automation/blogs/${id}`)
            .then(() => {
                alert("Success! Blog delete ho gaya.");
                fetchBlogs(); // List refresh karne ke liye
            })
            .catch(err => {
                console.error(err);
                alert("Delete fail ho gaya. Console check karo.");
            });
    }
    };

    if (loading) return <div className="p-8">Loading Blogs...</div>;

    return (
        <div className="p-8 max-w-5xl mx-auto">
            <h1 className="text-3xl font-bold mb-8 font-aligran">Manage Articles</h1>
            
            <div className="bg-white shadow-sm border border-gray-100 rounded-2xl overflow-hidden">
                {blogs.length === 0 ? (
                    <div className="p-10 text-center text-gray-500">No blogs found.</div>
                ) : (
                    blogs.map(blog => (
                        <div key={blog.id} className="flex items-center justify-between p-5 border-b border-gray-50 last:border-0 hover:bg-gray-50 transition">
                            <div className="flex-grow">
                                <h3 className="font-bold text-gray-900 text-lg mb-1">{blog.title}</h3>
                                <p className="text-sm text-gray-400 font-mono flex items-center gap-1">
                                    <ExternalLink size={14} /> /{blog.slug}
                                </p>
                            </div>
                            
                            <div className="flex gap-3">
                                <button 
                                    onClick={() => deleteBlog(blog.id)} 
                                    className="text-red-500 hover:bg-red-50 p-3 rounded-xl transition group"
                                    title="Delete Blog"
                                >
                                    <Trash2 size={20} className="group-hover:scale-110 transition-transform" />
                                </button>
                            </div>
                        </div>
                    ))
                )}
            </div>
        </div>
    );
};

export default ManageBlogs;